// src/components/ColorPicker.js - NEW FILE
import React from 'react';

const ColorPicker = ({ label, value, onChange, presetColors = [] }) => {
  const defaultPresets = [
    '#3B82F6', // Blue (current default)
    '#EF4444', // Red  
    '#10B981', // Green
    '#F59E0B', // Amber
    '#8B5CF6', // Purple
    '#06B6D4', // Cyan
    '#F97316', // Orange
    '#84CC16', // Lime
    '#EC4899', // Pink
    '#6B7280'  // Gray
  ];

  const colors = presetColors.length > 0 ? presetColors : defaultPresets;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      
      {/* Color Preview & Input */}
      <div className="flex items-center space-x-3 mb-3">
        <div 
          className="w-12 h-12 rounded-lg border-2 border-gray-300 cursor-pointer"
          style={{ backgroundColor: value }}
          title={`Current color: ${value}`}
        ></div>
        <div>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="#3B82F6"
            className="w-28 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          />
          <p className="text-xs text-gray-500 mt-1">Hex color code</p>
        </div>
      </div>

      {/* Preset Colors Grid */}
      <div className="grid grid-cols-5 gap-2">
        {colors.map((color, index) => (
          <button
            key={index}
            type="button"
            onClick={() => onChange(color)}
            className={`w-10 h-10 rounded-lg border-2 transition-all hover:scale-110 hover:shadow-md ${
              value === color 
                ? 'border-gray-800 ring-2 ring-gray-400 shadow-lg' 
                : 'border-gray-300 hover:border-gray-500'
            }`}
            style={{ backgroundColor: color }}
            title={color}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;